'use client';

import { OnboardingEvents, trackTagManagerEvent } from 'firebase-client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from 'ui';
import { useResolution } from 'ui/hooks';
import { FullscreenOutlined } from 'ui/icons';

import { useCreateContract } from '~/contract/hooks';
import { useDriveFile } from '~/contract/hooks/useDriveFile';
import { StepTitle } from '~/ui';

import ShowPdfFile from '../shared/ShowPdfFile';

export const ContractPreviewStep = () => {
  const { t } = useTranslation('createContractWizard');
  const { goToNextStep } = useCreateContract();

  const [showModal, setShowModal] = useState(false);
  const { isLargeTablet, isTablet } = useResolution();

  const { fileContent: contractFile, loading } = useDriveFile();

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <Box height="100%" display="flex" flexDirection="column" justifyContent="space-between">
      <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
        <StepTitle>{t('preview.title')}</StepTitle>
        {isLargeTablet && (
          <IconButton onClick={handleOpen} color="info" sx={{ padding: 0 }} data-testid="open-preview-button">
            <FullscreenOutlined fontSize="large" />
          </IconButton>
        )}
      </Box>
      <Dialog onClose={handleClose} open={showModal} maxWidth="xl">
        <DialogContent>
          {loading ? (
            <Typography>{t('fileLoading')}</Typography>
          ) : (
            <ShowPdfFile file={contractFile} loadingText={t('fileLoading')} />
          )}
        </DialogContent>
        <DialogActions>
          <Button size="sm" onClick={handleClose} data-testid="close-preview-button">
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
      <Box height="75%" sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
        {loading ? (
          <Typography>{t('fileLoading')}</Typography>
        ) : (
          <ShowPdfFile
            file={contractFile}
            loadingText={t('fileLoading')}
            scale={isTablet && !isLargeTablet ? 1.2 : 0.6}
          />
        )}
      </Box>
      <Box mt={1}>
        <Button
          fullWidth
          onClick={() => {
            trackTagManagerEvent(OnboardingEvents.contractPreview);
            goToNextStep();
          }}
          data-testid="sign-button"
          color="gradient"
        >
          {t('signing')}
        </Button>
      </Box>
    </Box>
  );
};
